<template>
  <!-- CART DROPDOWN -->
  <vs-dropdown
    vs-custom-content
    vs-trigger-click
    class="cursor-pointer"
    :key="dropdownKey"
  >
    <feather-icon
      :icon="cartIcon"
      class="cursor-pointer ml-4 mr-6 mt-1"
      :badge="cartItemsQty"
    />
    <vs-dropdown-menu
      class="cart-dropdown vx-navbar-dropdown"
      :class="{ 'dropdown-custom': cartItems.length }"
    >
      <!-- IF CART HAVE ITEMS: HEADER -->
      <template v-if="cartItems.length">
        <div class="notification-header text-center p-5 bg-primary text-white">
          <h3 class="text-white">
            {{ cartItemsQty }} Item<span v-show="cartItemsQty > 1"
              >s</span
            >
          </h3>
          <p class="opacity-75">{{ cartStatusText }}</p>
        </div>

        <!-- CART ITEMS -->
        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--cart-items-dropdowm p-0 mb-10"
          :settings="settings"
          :key="$vs.rtl"
        >
          <ul class="bordered-items">
            <li
              v-for="item in cartItems"
              :key="item.objectID"
              class="vx-row no-gutter cart-item cursor-pointer"
              @click="productDetail(item.productStoreId)"
            >
              <!-- IMG COL -->
              <div
                class="
                  vx-col
                  w-1/5
                  item-img-container
                  bg-white
                  flex
                  items-center
                  justify-center
                "
              >
                <img
                  :src="item.images[0].image"
                  alt="item"
                  class="cart-dropdown-item-img p-4"
                />
              </div>

              <!-- INFO COL -->
              <div
                class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center"
              >
                <span class="font-medium block cart-item-title truncate">{{
                  item.name
                }}</span>
                <div class="flex items-center justify-between">
                  <span class="text-sm font-medium"
                    >{{ item.quantity }} <small>x</small> {{ currency }}
                    {{ item.price | formatDecimals }}</span
                  >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="h-4 w-4 cursor-pointer text-danger"
                    class="hover:text-danger"
                    @click.stop="removeItemFromCart(item)"
                  />
                </div>
              </div>
            </li>
          </ul>
        </VuePerfectScrollbar>
        <div
          class="
            checkout-footer
            fixed
            bottom-0
            rounded-b-lg
            text-primary
            font-semibold
            w-full
            p-2
            text-center
            border border-b-0 border-l-0 border-r-0 border-solid
            d-theme-border-grey-light
            cursor-pointer
          "
          @click="viewCheckout"
        >
          <span class="flex items-center justify-center">
            <feather-icon :icon="cartIcon" svgClasses="h-4 w-4" />
            <span class="ml-2">{{ finaliseText }}</span>
          </span>
        </div>
      </template>

      <!-- IF CART IS EMPTY -->
      <template v-else>
        <p class="p-4">
          {{ cartEmptyText }}
        </p>
      </template>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapActions } from 'vuex';

import { CART } from '@/views/components/order-center/constants';

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      organizationId: null,
      dropdownKey: 0,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      currency: process.env.VUE_APP_CURRENCY,
      cartIcon: null,
      orderApprovalFlowEnabled: null,
      cartEmptyText: null,
    };
  },
  computed: {
    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },
    cartItemsQty() {
      let items = this.$store.state.eCommerce.cartItems;
      let count = 0;
      
      items.map(item => {
        count += item.quantity;
      });

      return count;
    },
    finaliseText() {
      if (this.$isAuRegion()) {
        return this.orderApprovalFlowEnabled ? 'Finalise Request' : 'Finalise';
      } else if (this.$isUSRegion()) {
        return this.orderApprovalFlowEnabled ? 'Finalize Request' : 'Finalize';
      }
      return 'Checkout';
    },
    cartStatusText() {
      return CART.CART_STATUS_TEXT(this.orderApprovalFlowEnabled).text;
    },
  },
  async created() {
    await this.getCartItems();
  },
  methods: {
    ...mapActions('ecommerce', ['getCartItemsFromApi']),
    ...mapActions('organization', ['fetchOrganizationClinicsList']),
    removeItemFromCart(item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item);
    },
    getClinics() {
      this.fetchOrganizationClinicsList({ id: this.organizationId, limit: 100 })
        .then((res) => {
          const results = res.data.data.docs.filter(
            ({ showStore }) => showStore
          );
          if (sessionStorage.getItem('doctorClinicSelectedClinic')) {
            if (results.length) {
              this.getCartItemsFromApi(
                sessionStorage.getItem('doctorClinicSelectedClinic')
              );
            }
          } else {
            if (results.length) {
              this.getCartItemsFromApi(results[0]._id);
              sessionStorage.setItem(
                'doctorClinicSelectedClinic',
                results[0]._id
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCartItems() {
      this.getCartItemsFromApi();
    },
    viewCheckout() {
      this.dropdownKey = Math.random();
      this.$router.push('/org-owner/checkout').catch(() => {});
    },
    productDetail(id) {
      let name = 'ClinicProductDetail';
      if (this.$store.state.AppActiveUser.userType === 'doctorClinic') {
        name = 'DoctorClinicProductDetail';
      }
      this.$router
        .push({
          name,
          params: { id },
        })
        .catch(() => {});
    },
    async initializeOrderApprovalFlow() {
      const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');

      try {
        this.orderApprovalFlowEnabled = await this.$isClinicOrderApprovalFlowEnabled(clinicId);
        this.cartIcon = this.orderApprovalFlowEnabled ? 'PackageIcon' : 'ShoppingCartIcon';
      } catch (error) {
        console.error('Error fetching clinic details:', error);
      }
    },
    getCartEmptyText() {
      this.cartEmptyText = CART.CART_EMPTY_TEXT(this.orderApprovalFlowEnabled).text;
    },
  },
  watch: {
    '$store.state.clinicId': async function () {
      this.getCartItems();
      await this.initializeOrderApprovalFlow();
      this.getCartEmptyText();
    },
    organizationId: function (val, oldVal) {
      if (!oldVal) {
        this.getClinics();
      }
    },
  },
  async mounted() {
    await this.initializeOrderApprovalFlow();
    this.getCartEmptyText();
  },
  beforeMount: async function () {
    if (
      localStorage.getItem(`${process.env.VUE_APP_PROCESS_TOKEN}OrganizationId`)
    ) {
      this.organizationId = localStorage.getItem(
        `${process.env.VUE_APP_PROCESS_TOKEN}OrganizationId`
      );
    }
  },
};
</script>
<style>
.con-vs-dropdown--menu.cart-dropdown {
  position: fixed;
  top: 48px !important;
}
</style>
